var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDevicePlanCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.02,
    height: 96.124,
    viewBox: "0 0 104.02 96.124",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "c73cl7nvzb",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 29 43"
  }, /*#__PURE__*/React.createElement("image", {
    width: 29,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAArCAYAAACEsIO/AAAABHNCSVQICAgIfAhkiAAAAfhJREFUWIXtmEFu4kAQRX9Vmb2PwA0yc4J4hITYJXMC2CF2wwnCDayIRS8nOUHIBrE0J5jMCeK5AQcA1yzittoxKBqS6sUoJVkWtO3Xv12/uoBQR5ZlKYCxqk4AfAEAIoKq+kvO/VwQUQHgtiiKHQBQDewT0YOHGcVOVb8VRfFEADAYDJ4B9P1Mrc4AdofD4WsyHA4XqhoCtwDuAJR+ic49M3MK4FpVx8wMVU1FZJEwcwYAqgpm3m42m+yDl3U1Go1KVb2pwWNm5gtmhoiAme8+GAgAYOZV/XzP4ZSZUR+lBXS9Xj8FDCTMHM7Igtl5dsLMHX9ZQT2nUeq/tAoRaewTTWltoRelItIasIqQkxBRA7NU619jVKUns9daaSd7w2W2gnpOS2m41BbQRqn3j2U1Ao5kr/ePpVL/+jrZaxktpTELfid7reNk9kZTGmavZXEIOVGz9+guY63URyuRohZ8HzG2tgYaduKW0KM9UlVVZtCTPVKSJGbQzx7p/+yRWlAgXo/UQKN3g696pNQCmOd5/9UEeCsi3kfXFlARybxPfXEoAVzW4+Plcvlrv98/zufz8r2wPM/TXq93pap54JLf5JzrV1X1fOymt37NnTNORN8JAJxzEwA//0nGeXE/m80mjUecc5mILFT10uB/pD+q+mM6na4A4C//lzvtQ8/EzwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "0ohsx6gvqc",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 41"
  }, /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAApCAYAAADEZlLzAAAABHNCSVQICAgIfAhkiAAAAU5JREFUWIXtmLttAkEURe+9bwpwCe7AdGBChFi5BJaYAJdgKlg7YUOvK2BFhERgl0AJlIBzxHOyiyzLH8nsTmDvCWc0OrrzpPk8omIwGPQBjN09rcdIwt3xFT/NA9gDKI/H48Nms9myEqUkH79bdS4kJxyNRn13f64G5ofDoViv17smBMPhsAcgJTkDACZJUgK4ITlfrVZ3TUg+kiRJAWAsSVeSIKloQwQAZlZIQpB0CQDL5XLXlgzAtgokmFmLHqAsy32drFVRzT+QkYwni8HfTWZm8ZKRhMws3jaSRIyt7GrWCGYWr2ZdskbokjUCSYS2Hzs1p2SxTpAu2dlETSYpXrLTTd3V7LdkWXZRn42vkpBl2WVbshBCr/6fvUhCCOG2LZmkmSQwz/PTBx7Avbs/TafTbROSxWJxTTKt2x0EgDzPP21NnNsHeT/v7pM3XElcOGZEq/QAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c3vjjar4ed",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 7 7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAABHNCSVQICAgIfAhkiAAAAHlJREFUCJl1jLENwzAMBJ+EKgKcJSNEA6hIqS08grNBYmgBD6E+8Ab2QNK7iQAXyTXX/L0AQEopApgBRJK7iKy11kVyzpHkR0RAEsOqugQze6oqSGLwHUzB3e/4QzCzQ1Vv18vh4O4rgNePcBMAKKW8e+/Tpdxaa48TRuw1GmzknHgAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "ln38z6aose",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 5 5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 5,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAAFFJREFUCJlNysENgCAURMG3wPWHWmyECki0A0uwBTqjIBLWiwfnPAJorQ3bpyT23kO992H75qdExCUJ4ACwPUutFYCUEmstcs6UiBiSHmB+kxfnjBo7feNtdQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "d68jx5fwqf",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 11 3"
  }, /*#__PURE__*/React.createElement("image", {
    width: 11,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAYAAABF//VLAAAABHNCSVQICAgIfAhkiAAAAD5JREFUCJljDAoKSmBkZJzPAAX///9nYGRkZEDn////fwGLlJTUBAYGBqwK0PgJLFJSUhcYGRntkUzARX8EAPyQJC4KG1QvAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "t193hem2kg",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 1,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAABCAYAAAAMwoR9AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljjI6OvsDIyKj///9/BkZGRgZsNAD58A4SF6YWiQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rlp8mu45ba",
    x: 0,
    y: 0,
    width: 104.02,
    height: 96.124,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2338"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1957"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#rlp8mu45ba)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 466",
    d: "M40.094 12h23.832A25.073 25.073 0 0 1 89.02 37.094V53.03a25.073 25.073 0 0 1-25.094 25.094H40.094A25.073 25.073 0 0 1 15 53.03V37.094A25.073 25.073 0 0 1 40.094 12z",
    style: {
      fill: "#fff"
    },
    transform: "translate(.005)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 35",
    d: "M6.8 0a6.779 6.779 0 1 1-2.647.534A6.779 6.779 0 0 1 6.8 0z",
    transform: "translate(78.581 11)",
    style: {
      fill: "#ffe200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 36",
    d: "M7.556 0a7.532 7.532 0 1 1-2.941.594A7.532 7.532 0 0 1 7.556 0z",
    transform: "translate(14.997 66)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1556"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 822",
    d: "M5.983 43.28a6.4 6.4 0 0 1-2.393-.449 5.6 5.6 0 0 1-3.135-3.144 6.452 6.452 0 0 1-.45-2.4Q0 35.741 0 34.2t0-3.1V5.994a6.566 6.566 0 0 1 .321-2.035 5.777 5.777 0 0 1 .9-1.712A5.542 5.542 0 0 1 2.615.953 5.911 5.911 0 0 1 4.444.175Q4.617.133 4.8.1t.37-.05q.192-.02.395-.031t.42-.01L8.546 0H23.23a6.388 6.388 0 0 1 2.391.449A5.6 5.6 0 0 1 28.763 3.6a6.454 6.454 0 0 1 .45 2.4v31.294a6.566 6.566 0 0 1-.289 1.939 5.874 5.874 0 0 1-.816 1.661 5.523 5.523 0 0 1-1.275 1.287 5.6 5.6 0 0 1-1.667.819 6.124 6.124 0 0 1-.937.204 7.175 7.175 0 0 1-.994.072l-2.453.006h-7.358zm.1-39.98a3.5 3.5 0 0 0-1.183.187 2.258 2.258 0 0 0-1.418 1.42A3.524 3.524 0 0 0 3.3 6.09v31.1a3.525 3.525 0 0 0 .186 1.184A2.259 2.259 0 0 0 4.9 39.8a3.5 3.5 0 0 0 1.181.187H23.14a3.5 3.5 0 0 0 1.18-.187 2.26 2.26 0 0 0 1.416-1.42 3.523 3.523 0 0 0 .186-1.184V6.09a3.524 3.524 0 0 0-.186-1.184 2.258 2.258 0 0 0-1.416-1.419 3.5 3.5 0 0 0-1.18-.187H6.078z",
    style: {
      fill: "url(#c73cl7nvzb)"
    },
    transform: "translate(39.076 23.299)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 823",
    d: "M27.91 20.989v15.644a5.974 5.974 0 0 1-.251 1.734 5.181 5.181 0 0 1-.716 1.477 4.825 4.825 0 0 1-1.128 1.142 4.991 4.991 0 0 1-1.487.729 5.42 5.42 0 0 1-.863.186 6.545 6.545 0 0 1-.883.062q-2.156.006-4.312.009H5.33a5.819 5.819 0 0 1-2.147-.394A4.891 4.891 0 0 1 .4 38.79a5.872 5.872 0 0 1-.4-2.157V5.34a5.965 5.965 0 0 1 .283-1.822 5.094 5.094 0 0 1 .789-1.524A4.857 4.857 0 0 1 2.312.848 5.3 5.3 0 0 1 3.944.157q.169-.041.341-.069t.348-.046q.175-.018.35-.026c.117-.005.233-.008.348-.008L9.644 0H22.58a5.823 5.823 0 0 1 2.148.4 4.888 4.888 0 0 1 2.783 2.788 5.887 5.887 0 0 1 .4 2.158v11.733l-.001 3.91zM1.988 20.94v15.6a4.16 4.16 0 0 0 .237 1.439 2.895 2.895 0 0 0 1.762 1.768 4.135 4.135 0 0 0 1.437.239h17.06a4.141 4.141 0 0 0 1.438-.238 2.893 2.893 0 0 0 1.763-1.767 4.161 4.161 0 0 0 .237-1.439V5.44A4.163 4.163 0 0 0 25.686 4a2.89 2.89 0 0 0-1.762-1.766 4.142 4.142 0 0 0-1.437-.238H5.425a4.145 4.145 0 0 0-1.437.238A2.889 2.889 0 0 0 2.226 4a4.165 4.165 0 0 0-.237 1.44V17.067l-.001 3.873z",
    transform: "translate(39.729 23.952)",
    style: {
      fill: "url(#0ohsx6gvqc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 824",
    d: "M3.64 7.3a3.729 3.729 0 0 1-.721-.072A3.648 3.648 0 0 1 .6 5.666a3.6 3.6 0 0 1-.533-1.308A3.717 3.717 0 0 1 0 3.638a3.619 3.619 0 0 1 .289-1.406A3.69 3.69 0 0 1 2.216.3a3.6 3.6 0 0 1 1.4-.3 3.748 3.748 0 0 1 .729.071 3.59 3.59 0 0 1 1.316.546 3.757 3.757 0 0 1 1.02 1.029 3.63 3.63 0 0 1 .541 1.327 3.709 3.709 0 0 1 .066.727 3.589 3.589 0 0 1-.3 1.4 3.667 3.667 0 0 1-1.932 1.914A3.615 3.615 0 0 1 3.65 7.3z",
    transform: "translate(50.04 55.275)",
    style: {
      fill: "url(#c3vjjar4ed)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 825",
    d: "M2.988 5.991a3.013 3.013 0 0 1-1.17-.237 2.99 2.99 0 0 1-1.58-3.919A3.037 3.037 0 0 1 1.82.243 2.945 2.945 0 0 1 4.144.235a3.025 3.025 0 0 1 1.838 2.806A2.959 2.959 0 0 1 5.1 5.132a2.981 2.981 0 0 1-2.108.86zm-.007-3.974a1 1 0 0 0-.906.6.975.975 0 0 0-.082.377.964.964 0 0 0 .076.391 1.024 1.024 0 0 0 .539.541A.966.966 0 0 0 3 4a.977.977 0 0 0 .39-.086 1.029 1.029 0 0 0 .53-.552.964.964 0 0 0 .069-.391A.976.976 0 0 0 3.9 2.6a.986.986 0 0 0-.218-.3 1 1 0 0 0-.316-.2 1.013 1.013 0 0 0-.385-.083z",
    transform: "translate(50.694 55.928)",
    style: {
      fill: "url(#ln38z6aose)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 826",
    d: "M1.719 3.292a1.936 1.936 0 0 1-.615-.1 1.667 1.667 0 0 1-.509-.275 1.549 1.549 0 0 1-.371-.426 1.616 1.616 0 0 1-.2-.551 1.743 1.743 0 0 1 0-.585A1.671 1.671 0 0 1 .21.828 1.582 1.582 0 0 1 .555.4a1.518 1.518 0 0 1 .482-.282 1.739 1.739 0 0 1 .21-.06 2.222 2.222 0 0 1 .409-.052c.064-.004.13 0 .191 0h7.575a2.556 2.556 0 0 1 .5.048 1.964 1.964 0 0 1 .392.121 1.655 1.655 0 0 1 .3.164 1.489 1.489 0 0 1 .21.178 1.473 1.473 0 0 1 .192.242 1.493 1.493 0 0 1 .137.277 1.63 1.63 0 0 1 .081.308 1.884 1.884 0 0 1 .024.335 1.688 1.688 0 0 1-.141.662 1.493 1.493 0 0 1-.375.511 1.69 1.69 0 0 1-.573.33 2.251 2.251 0 0 1-.737.117H5.726z",
    transform: "translate(48.057 27.308)",
    style: {
      fill: "url(#d68jx5fwqf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 827",
    d: "M4.983 0h3.784a1.77 1.77 0 0 1 .51.069 1.021 1.021 0 0 1 .372.2.816.816 0 0 1 .227.317 1.086 1.086 0 0 1 .072.427 1.045 1.045 0 0 1-.085.41.846.846 0 0 1-.232.307 1.044 1.044 0 0 1-.367.193 1.679 1.679 0 0 1-.49.068H1.066a1.268 1.268 0 0 1-.389-.061 1.029 1.029 0 0 1-.315-.165.921.921 0 0 1-.226-.255.948.948 0 0 1-.12-.327 1.111 1.111 0 0 1 0-.352 1.013 1.013 0 0 1 .1-.319.914.914 0 0 1 .2-.258.876.876 0 0 1 .289-.171 1.077 1.077 0 0 1 .143-.04 1.923 1.923 0 0 1 .301-.035c.049-.002.1 0 .151 0H4.983z",
    transform: "translate(48.71 27.958)",
    style: {
      fill: "url(#t193hem2kg)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDevicePlanCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-devicePlanCard.7b61deaf1e337ebac5b463e1b6833a2d.svg";